<template>
  <div class="row margin-0-mobile px-4 py-2 p-md-0 blueBG-mobile">
    <div class="col padding-0-mobile">
      <div class="input-group flex-column flex-md-row"> 
        <!-- Mobile: Suchfeld + Buttons in einer Zeile -->
        <div class="d-flex d-md-none mobile-search-row">
          <search-bar-text-field
              :config="config"
              :changeQuery="changeQuery"
              class="mobile-textfield"
          />
          <mobile-search-button
              :changeQuery="changeQuery"
              :textKey="config.textKeys.mobileSearchButton"
              class="mobile-btn"
            />
            <search-save v-if="showSaveSearch" class="mobile-btn" />
            <advanced-search-button 
            v-if="shouldShowAdvancedSearch"
            :datasets-count="getDatasetsCount"
            class="mobile-btn"
          />
        </div>

        <!-- Desktop: Original Layout -->
        <search-bar-text-field
            class="d-none d-md-block"
            :config="config"
            :changeQuery="changeQuery"
        /> 
        <search-scope-tabs v-if="!useCombinedSearch"
          :config="config"
        />
        <div class="d-none d-md-flex">
          <search-button
            :changeQuery="changeQuery"
          />
          <advanced-search-button v-if="shouldShowAdvancedSearch" :datasets-count="getDatasetsCount" />
        </div>

        <!-- Mobile Filters Dropdown + Facets Container -->
        <div v-if="isMobile" class="mobile-filters-section">
          <!-- <datasets-mobile-dropdown toggleElementId="#mobileDatasetFacets" /> -->
          <div class="mobile-facets-container collapse" id="mobileDatasetFacets">
            <datasets-facets v-if="useDatasetFacets" :dataScope="dataScope" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MobileSearchButton from "@/components/search/search-filters/MobileSearchButton";
import SearchBarTextField from "@/components/search/search-filters/SearchBarTextField";
import SearchScopeTabs from "@/components/search/search-filters/SearchScopeTabs";
import SearchButton from "@/components/search/search-filters/SearchButton";
import AdvancedSearchButton from "./AdvancedSearchButton.vue";
import SearchSave from "./SearchSave.vue";
import DatasetsMobileDropdown from "@/components/search/datasets/DatasetsMobileDropdown";
import DatasetsFacets from "@/components/search/datasets/datasetFacets/DatasetsFacets.vue";

export default {
  name: "SearchBar",
  components: {
    SearchButton,
    SearchScopeTabs,
    SearchBarTextField,
    MobileSearchButton,
    AdvancedSearchButton,
    SearchSave,
    DatasetsMobileDropdown,
    DatasetsFacets
  },
  props: {
    config: Object,
    showSaveSearch: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  data() {
    return {
      advancedSearch: this.$env.content.datasets.advancedSearch,
      useCombinedSearch: this.$env.content.useCombinedSearch,
      useDatasetFacets: this.$env.content.datasets.facets.useDatasetFacets,
      windowWidth: window.innerWidth,
      mobileFiltersOpen: false
    };
  },
  computed: {
    isMobile() {
      return this.windowWidth <= 790;
    },
    getQuery() {
      return this.$store.getters[
        `${this.config.getQuery[0]}/${this.config.getQuery[1]}`
      ];
    },
    getDatasetsCount() {
      if (this.config?.getDatasetsCount) {
        return this.$store.getters[`${this.config.getDatasetsCount[0]}/${this.config.getDatasetsCount[1]}`];
      }
      return this.$store.getters['datasets/getDatasetsCount'] || 0;
    },
    dataScope() {
      if (!this.$route.query.dataScope) return null;
      if (Array.isArray(this.$route.query.dataScope) && this.$route.query.dataScope.length > 0)
        return this.$route.query.dataScope[0];
      if (Array.isArray(this.$route.query.dataScope) && this.$route.query.dataScope.length === 0)
        return null;
      return this.$route.query.dataScope;
    },
    shouldShowAdvancedSearch() {
      if (this.$route.meta.hideAdvancedSearch) return false;
      return this.advancedSearch;
    },
  },
  methods: {
    setQuery(query) {
      this.$store.dispatch(
        `${this.config.setQuery[0]}/${this.config.setQuery[1]}`,
        query
      );
    },
    changeQuery(query) {
      if (!query) query = this.getQuery;
      this.$router
        .replace({
          query: Object.assign({}, this.$route.query, { query }, { page: 1 }),
        })
        .catch((error) => {
          console.error(error);
        });
      this.setQuery(query);
    },
     handleResize() {
      this.windowWidth = window.innerWidth;
    }
  },
   mounted() {
    // Event Listener für Fenster-Resize hinzufügen
    window.addEventListener('resize', this.handleResize);
    
  },
  beforeDestroy() {
    // Event Listener beim Zerstören der Komponente entfernen
    window.removeEventListener('resize', this.handleResize);
  },
}
</script>

<style lang="scss" scoped>
.input-group {
  flex-wrap: nowrap;
  width: 100%;
}

.mobile-search-row {
  width: 100%;
  gap: 4px;
  align-items: stretch;

  .mobile-textfield {
    flex: 1;
    min-width: 0;
  }

  .mobile-btn {
    flex-shrink: 0;
    
    :deep(button),
    :deep(.btn) {
      height: 100%;
      white-space: nowrap;
    }
  }
}

.mobile-filters-section {
  width: 100%;
  margin-top: 10px;
}

.mobile-facets-container {
  margin-top: 10px;
  margin-left: -28px;
  margin-right: -28px;

  :deep(.facet-group) {
    margin-bottom: 1.5rem;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
  
  :deep(.facet-title) {
    font-size: 1rem;
    font-weight: 600;
    margin-bottom: 0.75rem;
    color: #333;
  }
  
  :deep(.facet-items) {
    max-height: 200px;
    overflow-y: auto;
  }
}

@media screen and (max-width: 767.5px) {
  .input-group {
    flex-wrap: wrap;
    width: 100%;
  }

  .margin-0-mobile {
    margin: 0;
  }

  .blueBG-mobile {
    background-color: #f2f5f9;
    padding: 15px !important;
    margin: 0 -15px 0 -15px !important;
  }

  .padding-0-mobile {
    padding: 0;
  }
}
</style>